module.exports = "/_next/static/images/sports-a0b7d85684e6825442ce9d0da2f3f501.jpg";